import { render } from "./WhatsAppChat.vue?vue&type=template&id=8189cb1a&scoped=true"
import script from "./WhatsAppChat.vue?vue&type=script&lang=js"
export * from "./WhatsAppChat.vue?vue&type=script&lang=js"

import "./WhatsAppChat.vue?vue&type=style&index=0&id=8189cb1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8189cb1a"]])

export default __exports__